module.exports = __webpack_public_path__ + "static/media/product12.4c477028.jpg";